import { Client } from '@/utilities/api/Client';
import { QueryUtil } from '@/utilities/Query';
import { CountyEndpoint } from '@api/endpoints';

export class CountyApi {
  static list (
    query: CountyEndpoint.List.Query,
  ): Promise<CountyEndpoint.List.Response> {
    return Client(`counties?${QueryUtil.stringify(query)}`);
  }
}
